import { MANAGER_EDIT_OWN_ATTENDANCES } from '@/constants/Restrictions';

export const isOwnAttendanceEditBlocked = (currentUserId, restrictions, employeeId) =>
  currentUserId === employeeId && restrictions.includes(MANAGER_EDIT_OWN_ATTENDANCES);
